import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DTFHomepageService } from '../dtfhomepage/dtfhomepage.service';
import { AuthorizationService } from '../authorization/authorization.service';
import { WindowRef } from '../../utils/window';
import { TranslateService } from '@ngx-translate/core';
import { Banner } from '../../shared/models/banner';
import { TranslateUtil } from '../../utils/translate-util';
import { APP_CONSTANTS } from '../../utils/app-constants';
import { AccoutDetailsResponse } from '../../shared/models/accountDetailsResponse';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SharedTranslateModule } from '../../utils/sharedTranslateModule';

enum CheckeBill {
  Enroll_ebill,
  Terminate_ebill,
  NONE
};



export enum ToggleEnum { //used for mat toggle
  Option0,
  Option1,
  Option2,
  Option3,
  Option4,
  Option5,
  Option6,
  Option7,
  Option8,
  Option9,
}

@Component({
    selector: 'div.dtf-paypage',
    imports: [SharedTranslateModule,
        MatTableModule, MatCheckboxModule, MatFormFieldModule,
        MatInputModule, FormsModule, MatSelectModule, ReactiveFormsModule, MatButtonToggleModule, MatSortModule
    ],
    templateUrl: './pay.component.html',
    providers: [],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ]
})


export class PayComponent implements OnInit {
  title = 'Content Section of the Page';
  private _window: WindowRef;
  router: Router;
  path = '';
  token: string;
  enrollFlagFromDB: string;
  countryFlag: string;
  langFlag: string;
  currentCountry: string;
  isCanadaPortal = false;
  baseUrl = '';
  usUrl: string;
  caUrl: string;
  olpUrl :string;
  azURL: string;
  agentview: string;
  agentId: string;
  userDcsAccount: string;
  emailAddress: string;
  hideSingleSelectionIndicator=true;
  customerName: string;
  bodyLoaded = false;
  dbLoaded = false;
  isFrench = false;
  tableLoaded=false;
  openLoginModal = false;
  serviceErrorOccurred = false;
  serviceErrorDesc = '';
  userId = '';
  dbData: any;
  public alerts: Banner;
  toggleOpen: any;
  recAccCount = '';
  totalDue = '';
  language = '';
  emailOffers = true;
  isReset = false;
  userExist = false;
  marked = false;
  ciamId = sessionStorage.getItem('loginID');
  thirdPartyNumber = sessionStorage.getItem('thirdPartyNumber');
  accountDetailsRes: AccoutDetailsResponse[];
  make_payment = false;
  principal_payment = false;
  trans_history = false;
  invoice_payment = false;
  invoice_history= false;
  trk_recurring=false;
  trk_recurring_history=false;
  bank_profile=false;
  help=false;
  SelectEnrollForm = false;
  SelectTerminateForm = false;
  disabledFlag =false;
  dataLoaded=true;
  olpredirecturl: any = null;
  CANCEL = '';

  //used for mat-toggle
  toggleEnum = ToggleEnum;
  selectedState = ToggleEnum.Option0;

  filterActive = false;
  filter = false;
  rowCount = 0;
  value = '';
  EncryptionRequest: any ={}
  


  constructor(router: Router, private dtfhomepageService: DTFHomepageService, private fb: FormBuilder, public auth: AuthorizationService,
    window: WindowRef, public translate: TranslateService, public translateUtil: TranslateUtil, private sanitizer: DomSanitizer
  ) {
    this.router = router;
    this._window = window;
    this.usUrl = (this._window.nativeWindow as any).mbfs.usUrl;
    this.caUrl = (this._window.nativeWindow as any).mbfs.caUrl;
    this.olpUrl = (this._window.nativeWindow as any).mbfs.olpUrl;
  }

  ngAfterViewInit() {
  }

  onChangeButton($event) { //Used for mat-toggle conditions to filter DB
     this.selectedState = $event.value;
    this.disabledFlag = false;
    var pageredirect = "make_payment";
    if (this.selectedState === 0) {
      pageredirect= "make_payment";
    //   this.azURL =  this.usUrl + '/home/onlinepayment';
    //   setTimeout(() => {
    //     this._window.nativeWindow.location.href = this.azURL;
    // }, 1000);
    }
    else if (this.selectedState === 1) {
      // this.principal_payment = true;
      pageredirect= "principal_payment";
    }
    else if (this.selectedState === 2) {
       this.trans_history = true;
      pageredirect= "trans_history";
    }
    else if (this.selectedState === 3) {
      //  this.invoice_payment = true;
      pageredirect= "invoice_payment";
    }
    else if (this.selectedState === 4) {
      // this.bank_profile = true;
      pageredirect= "bank_profile";
    }
    if (this.selectedState === 5) {
      //  this.invoice_history = true;
      pageredirect= "invoice_history";
    }
    else if (this.selectedState === 6) {
      // this.trk_recurring = true;
      pageredirect= "trk_recurring";
    }
    else if (this.selectedState === 7) {
      pageredirect= "trk_recurring_history";
    }
    else if (this.selectedState === 8) {
      //  this.help = true;
      pageredirect= "help";
    }
    this.encryptCTR(pageredirect);
  }


  ngOnInit() {
    this.agentview = sessionStorage.getItem('agentview');
    this.agentId = sessionStorage.getItem('agentID');
    this.customerName = sessionStorage.getItem('customerName');
    this.emailAddress = sessionStorage.getItem('emailAddress');
    const language = (window as any).mbfs.language;
    this.language= language;
    const country = (window as any).mbfs.country;
    this.countryFlag = country;
    this.langFlag = language;
    this.token = sessionStorage.getItem('ciamToken');

    this.translateUtil.setCountryAndLangFromUIProp();
    this.translateUtil.getCurrentCountry().subscribe(val => {
      this.isCanadaPortal = (val === APP_CONSTANTS.COUNTRY_CA) ? true : false;
      this.currentCountry = val;
    });
    const dashBoardRequest = {
      ciamId: this.ciamId,
      ciamAZCode: this.token
    };

    this.getDashBoardDetails(dashBoardRequest);
    this.getAccountDetailsListByUserId();
   // this.getAlerts();
  }

  anouncementMgsopen(e: any) {
    e.preventDefault();
    if (this.toggleOpen) {
      this.toggleOpen = false;
    } else {
      this.toggleOpen = true;
    }
  }

  // getAlerts() {
  //   this.dtfhomepageService.getAlerts().subscribe((res) => {
  //     for (var i = 0; i < res.length; i++) {
  //       if (this.currentCountry === 'CA') {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerName.indexOf((this.langFlag)) !== -1 &&
  //           res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'CA') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //       else {
  //         if (res[i].bannerType === 'Alert' && res[i].bannerEnable === 'Y' && res[i].bannerCountry === 'US') {
  //           this.alerts = res[i];
  //           this.dbData = true;
  //         }
  //       }
  //     }
  //   });
  // }

  formValidationClasses = {
    'mbfs-error': true,
  };

  getDashBoardDetails(dashBoardRequest) {
      this.auth.getDashBoardDetails(dashBoardRequest).subscribe(res => {
      this.recAccCount = res.recAccCount;
      this.totalDue = res.totalDue;
      if (this.totalDue.includes("-")) {
        this.totalDue = "0.00";
      }
    });
  }

  closeCIAMModal(e: Event) {
    this.openLoginModal = false;
    this.userExist = false;
    this.isReset = false;
    this.serviceErrorOccurred = false;
  }

  getAccountDetailsListByUserId() {
    const accountDetailsRequest = {
      ciamId : this.ciamId ,
      ciamAZCode :this.token
    };
    this.auth.getAccountDetailsListByUserId(accountDetailsRequest).subscribe(res => {
      this.accountDetailsRes = res.accountdetailsList;
      this.userDcsAccount = this.accountDetailsRes[0].contractNum; //used for userDcsAccount
      this.encryptCTR("make_payment");
    });
  }


  encryptCTR(pageredirect){
    this.tableLoaded = false;
    // var userDcsAccount = "1x85zd1mm2j7o,aazsgw7d4yvh";
    // var page = "make_payment";
    // var email="-187285s28mk02,-9z3l3ab3ckdy,-tif2j9bahsoc,-z2e8o5shibca,-88yzg6hxzaf5";
    // var userid = "-1bf1hp4u0ci8s,-1jk7md3lp8776,-al7jpib067tr";
    // var sessionId ="-1786lcq8mwgas,vy3nmdjts5h3,-1u9vx3m63al2c,a8mm96xc7s1j,ofv0hueokk2"
    // var cCANNumber ="-t77ci0d88wua,eqg6gj3rr3ep";
    // var agentView = "false";
    // var custName ="-va6bpefc2zu8,-12dd9oq7efwgu,-al7jpib067tr&userId=1p6yx2n7xsznn,-742ql3z0iwe3,-al7jpib067tr";
    // var colorCode ="&colorCode=TRK";
   
    var userDcsAccount = this.userDcsAccount;
    var page = '?page='+ pageredirect;
    var email=this.emailAddress;
    var userid = this.ciamId;
    var sessionId =this.token;
    var cCANNumber =this.thirdPartyNumber;
    var agentView = this.agentview;
    var custName =this.customerName;
    var colorCode ="&colorCode=TRK";
    var selectedAccount = "&selectedAccount=All"

    var tempnames = ["&userDcsAccount=","&email=", "&userId=", "&cCANNumber=","&custName="]
    var tempvalues =[userDcsAccount, email,userid, cCANNumber,custName];
   
    var payoffcheck = sessionStorage.getItem('page');
    if (payoffcheck === 'payoff_quote' ){
      var page = '?page='+ payoffcheck;
      var amount = sessionStorage.getItem('amount');
      var quoteNumber = sessionStorage.getItem('quoteNumber');
      var selectedAcct  = sessionStorage.getItem('selectedAcct');

      var payoffnames = ["&amount=","&selectedAcct=", "&quoteNumber="];
      var payoffvalues = [amount, selectedAcct, quoteNumber];
      tempnames.push(payoffnames[0],payoffnames[1],payoffnames[2]);
      tempvalues.push(payoffvalues[0],payoffvalues[1],payoffvalues[2]);

      sessionStorage.removeItem('page'); //prevent payoff from loading again
      sessionStorage.removeItem('amount'); //prevent payoff from loading again
      sessionStorage.removeItem('selectedAcct'); //prevent payoff from loading again
      sessionStorage.removeItem('quoteNumber'); //prevent payoff from loading again

    }
    this.EncryptionRequest = {};
    this.EncryptionRequest = {
     values: tempvalues
   };
    this.auth.encryptCTR(this.EncryptionRequest).subscribe(res => {
      var tempurl = this.olpUrl + page  + selectedAccount +colorCode + "&sessionId=" + sessionId + "&agentView=" +agentView; 
      // var originalurl = this.olpUrl + page + selectedAccount +colorCode + "&sessionId=" + sessionId +"&agentView=" +agentView; 
      for(var i =0; i < res.values.length; i++){
        var temp = tempnames[i] + res.values[i].toString(); 
        // var tempprigin = tempnames[i] + tempvalues[i].toString(); 
        tempurl  += temp;
        // originalurl += tempprigin;
      }
      // var tempurl = this.olpUrl  + userDcsAccount + page + email + userid + "&sessionId=" + sessionId + cCANNumber + "&agentView=" +agentView  + custName + colorCode;
      this.olpredirecturl = this.sanitizer.bypassSecurityTrustResourceUrl(tempurl);
      this.make_payment = true;
      setTimeout(() => {
        this.tableLoaded = true;
      }, 500); //2s
      });
    
  }
}
